import { authService } from './authService';

const parseJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error("❌ فشل فك التوكن:", e);
        return null;
    }
};

const isTokenExpired = (token) => {
    if (!token) return true;
    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
};

let refreshPromise = null;

export const setupInterceptors = (axiosInstance) => {

    // 1️⃣ معالجة إرسال الطلبات والتوكن
    axiosInstance.interceptors.request.use(
        async (config) => {
            if (config.url?.includes('/auth/refresh')) {
                return config;
            }

            let token = localStorage.getItem('token') || localStorage.getItem('Token') || localStorage.getItem('access_token');

            if (token) {
                const expired = isTokenExpired(token);

                if (expired) {
                    if (!refreshPromise) {
                        console.warn("⚠️ Access Token منتهي! جاري استدعاء الـ Refresh Endpoint الآن...");
                        refreshPromise = authService.refreshToken()
                            .finally(() => {
                                refreshPromise = null;
                            });
                    }

                    try {
                        const newToken = await refreshPromise;
                        if (newToken) {
                            token = newToken;
                        } else {
                            // في حال كانت العودة عبر الكوكيز
                            token = localStorage.getItem('token') || localStorage.getItem('Token') || localStorage.getItem('access_token');
                        }
                    } catch (err) {
                        console.error("❌ فشل استدعاء Refresh Endpoint:", err);
                    }
                }

                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // 2️⃣ 🟢 الإضافة الأساسية: معالجة الردود واعتراض أخطاء التجميد والحذف (Response Interceptor)
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                const detailMsg = typeof error.response.data?.detail === 'string' 
                    ? error.response.data.detail 
                    : JSON.stringify(error.response.data?.detail || '');

                // مسح التخزين والتوجيه لصفحة الدخول في حال كانت الشركة مجمّدة أو ممسوحة
                if (
                    detailMsg.includes("مجمّد") || 
                    detailMsg.includes("تجديد") || 
                    detailMsg.includes("مراجعة") || 
                    detailMsg.includes("انتهت فترة") ||
                    detailMsg.includes("حذف")
                ) {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/auth';
                }
            }
            return Promise.reject(error);
        }
    );
};